import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (resources: ContentNugget[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Resources',
    description:
      'Curated nuggets attached to this opportunity to help the user choose, apply, and interview.',
  });

  useRegisterAgentContext({
    kind: 'nuggetList',
    description: 'Resources curated for this opportunity',
    nuggets: resources.map(toAgentContextNugget),
  });
};
